// =============================================================================
// ConfirmModal - modal CENTRAL para avisos/confirmações (substitui window.confirm)
// =============================================================================
// Padrão do redesign: modais laterais (Sheet) para adicionar/editar; modais
// CENTRAIS para informações, avisos e confirmações. Use este para toda pergunta
// "Confirma?" que antes era window.confirm/alert.
// =============================================================================

import { AlertTriangle } from 'lucide-react';

interface ConfirmModalProps {
  aberto: boolean;
  titulo: string;
  /** Mensagem (string com \n vira parágrafos) ou conteúdo JSX. */
  mensagem: React.ReactNode;
  textoConfirmar?: string;
  textoCancelar?: string;
  processando?: boolean;
  /** 'perigo' deixa o botão de confirmar vermelho; 'padrao' usa o laranja da marca. */
  tom?: 'padrao' | 'perigo';
  onConfirmar: () => void;
  onCancelar: () => void;
}

export default function ConfirmModal({
  aberto,
  titulo,
  mensagem,
  textoConfirmar = 'Confirmar',
  textoCancelar = 'Cancelar',
  processando = false,
  tom = 'padrao',
  onConfirmar,
  onCancelar,
}: ConfirmModalProps) {
  if (!aberto) return null;

  const corConfirmar =
    tom === 'perigo'
      ? 'bg-red-600 hover:bg-red-700'
      : 'bg-otm-orange hover:bg-otm-orange-dark';

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-[80] p-4"
      onClick={processando ? undefined : onCancelar}
    >
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 pt-5 pb-3 flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center shrink-0">
            <AlertTriangle size={18} />
          </div>
          <div className="min-w-0">
            <h3 className="text-base font-bold text-otm-txt-1">{titulo}</h3>
            <div className="mt-1 text-sm text-otm-txt-2 space-y-2 whitespace-pre-line">{mensagem}</div>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-otm-border">
          <button
            type="button"
            onClick={onCancelar}
            disabled={processando}
            className="text-xs font-medium text-otm-txt-2 hover:text-otm-txt-1 px-3 py-2 rounded-lg disabled:opacity-50"
          >
            {textoCancelar}
          </button>
          <button
            type="button"
            onClick={onConfirmar}
            disabled={processando}
            className={`text-xs font-semibold text-white px-4 py-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${corConfirmar}`}
          >
            {processando ? 'Processando…' : textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}
